module.exports = __webpack_public_path__ + "img/halalcert.28634891.png";